import { render } from "./FloatingDots.vue?vue&type=template&id=03c4f8aa&scoped=true&ts=true"
import script from "./FloatingDots.vue?vue&type=script&lang=ts"
export * from "./FloatingDots.vue?vue&type=script&lang=ts"

import "./FloatingDots.vue?vue&type=style&index=0&id=03c4f8aa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03c4f8aa"]])

export default __exports__